<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowPrintPdfPopup" ref="mustShowPrintPdfPopup" persistent max-width="50%" class="popup-scoring" id="close-pdf-popup">
                <v-card class="popup-scoring confirm-pdf-print">
                    <v-card-title class="headline">
                        <span class="font-weight-light">{{text('api.scoring.pdf.popup.title')}}</span>
                        <span  @click="hideLabelPopup()" class="float-right">
                              <img alt="close icon" src="../../../assets/svg/material-icons-alternatives/Close_White.svg" width="24px" height="24px">
                        </span>
                    </v-card-title>
                    <input>
                    <v-card-text>
                        <v-flex xs12 md6>
                            <span class="font-weight-light text-sealed">{{text('api.scoring.pdf.popup.text')}}</span>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="printPdf()">OK</v-btn>
                        <v-btn @click="hideLabelPopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import axios from 'axios';

export default {
        name: 'ConfirmPrintPdfPopup',

        data() {
            return {
                label_value: '',
                validated: false
            }
        },

        computed: {
            ...mapGetters({
                mustShowPrintPdfPopup: 'ScoringStore/getMustShowPrintPdfPopup',
                datasummary: 'SummaryStore/getSummaryDataNew',
                getAssessmentVersion: 'SummaryStore/getAssessmentVersion'
            }),
        },

        created: function () {
            document.addEventListener('keydown', this.handleKeyDowns);
            document.addEventListener('keyup', this.handleKeyUps);
        },

        destroyed: function () {
            document.removeEventListener('keydown', this.handleKeyDowns);
            document.removeEventListener('keyup', this.handleKeyUps);
        },

        methods: {
            ...mapActions({
                showPrintPdfPopup: 'ScoringStore/showPrintPdfPopup'
            }),

            hideLabelPopup() {
                this.$store.commit('ScoringStore/setMustShowPrintPdfPopup', false);
            },

            printPdf() {
                console.log("print pdf");
                this.$store.commit('ScoringStore/setMustShowPrintPdfPopup', false);

                let requestParams = {
                    assessmentToken: null,
                    pdfTemplateType: "PRO",
                    decisionItem1Label: null,
                    decisionItem1Color: null,
                    decisionItem2Label: null,
                    decisionItem2Icon: null,
                    decisionText: "",
                    disclaimer1: "",
                    disclaimer2: ""

                };

                if (typeof this.$route.query.assessmentId !== "undefined") {
                    requestParams.assessmentToken = this.datasummary.overview.assessmentToken;
                    requestParams.assessmentVersion = this.getAssessmentVersion;

                } else if (this.$route.query.assessment) {
                    requestParams.assessmentToken = this.$route.query.assessment;
                    requestParams.assessmentVersion = this.getAssessmentVersion;
                } else {
                    requestParams.assessmentToken = null;
                    requestParams.assessmentVersion = null;
                }

                let axiosRequest = axios.post(
                    process.env.API_BASE_URL + '/assessment/deliverPDF',
                    requestParams,
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/pdf'
                        }
                    }
                );

                axiosRequest.then((response) => {

                    this.$store.commit('ScoringStore/setIsAssessmentSealed', true);

                    const attachment_name = response.headers["attachement-file-name"];

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), attachment_name); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        if (attachment_name == null || attachment_name == "") {
                            link.setAttribute('download', "assessment_case.pdf"); //or any other extension
                        } else {
                            link.setAttribute('download', attachment_name); //or any other extension
                        }

                        document.body.appendChild(link);
                        link.click();
                    }
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns(event) {

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                }

                if (this.mustShowPrintPdfPopup === false) {
                    return;
                }

                // Confirm Print Pdf
                switch (event.keyCode) {

                    // Backspace
                    case 8:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false

                    // Enter
                    case 13:
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                            // CTRL + Enter = OK
                            this.$parent.shortcutNav.crtField = null;
                            this.printPdf();
                        }
                        break;

                    // Escape
                    case 27:
                        this.hideLabelPopup();
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // focus on textarea comment from the main page
                            event.preventDefault();
                            this.hideLabelPopup();
                            this.navPatientCommentFocusFromPopup();
                        }
                        break;
                }
            },

            handleKeyUps(event) {

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                }
            },

            navPatientCommentFocusFromPopup() {

                // Activate navigation on MyDecisionPanel and PatientComment textarea
                if (this.$parent.shortcutNav.isKeyboardNav === false) {
                    // Entering in navigation mode
                    this.$parent.shortcutNav.isKeyboardNav = true;
                }

                this.$parent.shortcutNav.crtPanel = "MY_DECISION";
                this.$parent.shortcutNav.crtField = "PATIENT_COMMENT";

                this.$parent.navScrollOnActivePanel();

                /**
                 * Focus on patient comment textarea. Add border with primary color, for 1 second.
                 */
                let that = this.$parent;
                if (this.$parent.getIsAssessmentSealed === true) {
                    setTimeout(function () {
                        that.shortcutNav.crtField = null
                    }, 500);
                }

                // Patient comment Textarea will be directly editable if the panel is not disabled
                if (this.$parent.getIsAssessmentSealed === false) {
                    this.$parent.shortcutNav.isFieldInEdit = true;
                }

                // Sanity assignment for having the same configuration
                this.$parent.shortcutNav.isPanelHighlight = false;

                this.$parent.$refs['PATIENT_COMMENT'].$refs.input.focus();
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/professional/components/scoring/ConfirmPrintPdfPopup.vue